import { useSyncExternalStore } from 'react';

import { type ColorScheme } from '@/ui/theme/types/ColorScheme';

const DARK_MODE_MEDIA_QUERY = '(prefers-color-scheme: dark)';

const subscribeToColorSchemeChanges = (onChange: () => void) => {
  const mediaQueryList = window.matchMedia(DARK_MODE_MEDIA_QUERY);
  mediaQueryList.addEventListener('change', onChange);

  return () => mediaQueryList.removeEventListener('change', onChange);
};

const getSystemColorScheme = (): ColorScheme =>
  window.matchMedia(DARK_MODE_MEDIA_QUERY).matches ? 'dark' : 'light';

export const useSystemColorScheme = () =>
  useSyncExternalStore(subscribeToColorSchemeChanges, getSystemColorScheme);
